import { createTheme } from "@mui/material"

import { BASE_THEME_CONFIG } from "./baseTheme"
import {
    ENA_BLUE_1OO,
    ENA_BLUE_20,
    ENA_ORANGE_100,
    ENA_ORANGE_20,
    ERROR_DARK,
    ERROR_LIGHT,
    ERROR_MAIN,
    SUCCESS_DARK,
    SUCCESS_LIGHT,
    SUCCESS_MAIN,
    WARNING_DARK,
    WARNING_LIGHT,
    WARNING_MAIN,
    WHITE,
} from "./colours"
import { responsiveTypography } from "./typography"

// Augment theme type with custom values
declare module "@mui/material/styles" {
    interface TypeBackground {
        contentBackground: string
        frameBackground: string
        successBackground?: string
    }
}

const lightTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            frameBackground: WHITE,
            contentBackground: "#EDF2F5",
            successBackground: "#EDF7ED",
            paper: WHITE,
        },
        text: {
            primary: "#364152",
        },
        primary: {
            main: ENA_BLUE_1OO,
            light: ENA_BLUE_20,
            contrastText: WHITE,
        },
        secondary: {
            main: ENA_ORANGE_100,
            light: ENA_ORANGE_20,
            contrastText: WHITE,
        },
        success: {
            main: SUCCESS_MAIN,
            light: SUCCESS_LIGHT,
            dark: SUCCESS_DARK,
            contrastText: WHITE,
        },
        error: {
            main: ERROR_MAIN,
            light: ERROR_LIGHT,
            dark: ERROR_DARK,
            contrastText: WHITE,
        },
        warning: {
            main: WARNING_MAIN,
            light: WARNING_LIGHT,
            dark: WARNING_DARK,
            contrastText: WHITE,
        },
    },
    ...BASE_THEME_CONFIG,
})

export default responsiveTypography(lightTheme)
